<template>
  <div>
    <button
      class="btn btn-primary btn-sm"
      data-toggle="tooltip"
      data-placement="top"
      title="Test Run"
      @click="fnShowModal()"
    >
      Test Run
    </button>

    <b-modal ref="modal" size="sm" hide-footer title="EM Test Run">
      <div class="d-block">
        <form v-on:submit.prevent="createTestRun">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="firstName"
                />
                <label class="floatingLabel" for="title">First name</label>
                <div class="invalid-feedback" v-if="errors.first_name">
                  {{ errors.first_name[0] }}
                </div>
              </div>

              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  placeholder=""
                  v-model="email"
                />
                <label class="floatingLabel" for="title">Email</label>
                <div class="invalid-feedback" v-if="errors.email">
                  {{ errors.email[0] }}
                </div>
              </div>
            </div>
          </div>

          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-sm">
              <b-spinner v-if="isSpinner" small class="mr-2"></b-spinner>Submit
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import * as messageService from '../../services/message.service'
import * as emService from '../../services/em.service'
export default {
  name: 'ModalEMTestRun',
  components: {},
  data() {
    return {
      errors: {},
      firstName: '',
      email: '',
      isSpinner: false
    }
  },
  computed: {
    ...mapGetters(['getEMWizardStep', 'getEMWizardData'])
  },
  methods: {
    ...mapActions(['fetchEMWizardStep', 'fetchEMWizardData']),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    createTestRun: async function () {
      this.isSpinner = true
      try {
        let obj = {
          runMode: 'test',
          firstName: this.firstName,
          email: this.email
        }
        await this.fetchEMWizardData({ ...this.getEMWizardData, ...obj })

        await emService.wizardPost(this.getEMWizardData)
        messageService.fnSweetAlertSuccessToast(
          'EM',
          'Send Test run successfully '
        )
        this.isSpinner = false
      } catch (error) {
        messageService.fnSweetAlertErrorToast('EM', error.response.data.message)
        this.isSpinner = false
      }
    }
  }
}
</script>
